export default __webpack_public_path__ + "static/media/berat.8185c885.png";